import { Button } from '@/components/ui/button';

interface LoadMoreButtonProps {
  /** useInfiniteQuery 결과 중 다음 페이지 로딩에 필요한 부분만 받는다. */
  query: {
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => Promise<unknown>;
  };
}

/** 누적 목록의 "더 보기" — 다음 페이지가 있을 때만 렌더하고, 불러오는 동안 잠근다. */
export function LoadMoreButton({ query }: LoadMoreButtonProps) {
  if (!query.hasNextPage) return null;
  return (
    <Button
      variant="outline"
      onClick={() => void query.fetchNextPage()}
      disabled={query.isFetchingNextPage}
    >
      {query.isFetchingNextPage ? '불러오는 중…' : '더 보기'}
    </Button>
  );
}
